// TODO: Duplicated by user/analysis/dashboard.js

import { page, bootstrapSelect, introJS, dateRangePicker } from '../../init'

$(function() {
  if (page.controllerPath().startsWith('user/profile_groups/log')) {
    console.debug('[JS] daterangepicker')
    dateRangePicker.trigger('#reportrange')

    console.debug('[JS] bootstrap-select')
    bootstrapSelect.trigger({showSubtext: true})

    console.debug('[JS] intro.js')
    introJS.onClick('#intro-start')
  }
})
